module.exports = __webpack_public_path__ + "static/img/index-bg.da58b14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index-bg.png
// module id = l5lu
// module chunks = 1